import { gsap, ScrollTrigger, smoothScrollObj, Modal } from "../layout"

import Swiper from 'swiper';
import { Pagination, Navigation, EffectFade, Autoplay } from 'swiper/modules';

function homeBannerSwiper() {
    const swiper = new Swiper(".banner__swiper", {
        modules: [ Pagination, EffectFade, Autoplay ],
        spaceBetween: 30,
        effect: "fade",
        speed: 1000,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".banner__pagination",
            clickable: true,
        },
    });
}

function reasonSection() {
    const reasonTrigger = document.querySelector('.reason > .theme-container');
    const reasonImage = document.querySelector('.reason__image');
    const reasonImageDecoration = document.querySelector('.reason__image-decoration');
    const reasonimageContainer = document.querySelector('.reason__image-container');

    let triggerStart, heightImageFrom, heightImageTo;
    if(window.innerWidth >= 992) {
        heightImageFrom = 0
        heightImageTo = "auto"
        triggerStart = "top center+=100"
    } else {
        heightImageFrom = "100%"
        heightImageTo = "100%"
        triggerStart = "top center"
    }

    let reasonImageTl = gsap.timeline({
        scrollTrigger: {
            trigger: reasonTrigger,
            start: triggerStart,
            // markers: true,
        }
    });
    reasonImageTl.fromTo(reasonimageContainer, {
        height: heightImageFrom,
    }, {
        height: heightImageTo,
        duration: 1,
        ease: "power3.inOut",
    })
    .fromTo(reasonImage, {
        scale: 1.3
    }, {
        scale: 1,
        duration: 1,
        ease: "power2.inOut",
    }, "-=1")
    .fromTo(reasonImageDecoration, {
        autoAlpha: 0,
        // yPercent: 100
    }, {
        autoAlpha: 1,
        // yPercent: 0,
        duration: 1,
        ease: "ease",
    }, "-=0.4")

}

function serviceSection() {
    const serviceRow = document.querySelector('.service__row');
    const serviceItemHover = document.querySelectorAll('.service__image-container');
    const serviceItem = document.querySelectorAll('.service__image-wrapper');
    const serviceImage = document.querySelectorAll('.service__image');

    let heightFrom, heightTo;
    if(window.innerWidth >= 992) {
        heightFrom = "0%"
    } else {
        heightFrom = "100%"
    }

    let serviceTl = gsap.timeline({
        scrollTrigger: {
            trigger: serviceRow,
            start: "top center+=100",
            // markers: true,
        },
    });
    serviceTl.fromTo(serviceItem, {
        height: "0%"
    }, {
        height: "100%",
        duration: 0.8,
        stagger: 0.3,
        ease: "power3.inOut",
    })
    .fromTo(serviceImage, {
        scale: 1.2
    }, {
        scale: 1,
        duration: 0.8,
        stagger: 0.3,
        ease: "power2.inOut",
        onComplete: () => {
            serviceItem.forEach((item) => {
                item.remove();
            })

            gsap.to(serviceImage, {
                transition: '0.5s ease',
            })
        }
    }, "-=1.4")
}
function serviceResponsive() {
    const serviceItemHover = document.querySelectorAll('.service__image-container');

    serviceItemHover.forEach((item) => {
        let serviceName = item.querySelector('.service__name');
        let serviceDescription = item.querySelector('.service__description-contact');
        let serviceDescriptionHeight = serviceDescription.offsetHeight;

        let topPositionFrom;
        if (window.innerWidth >= 992) {
            topPositionFrom = `${serviceDescriptionHeight}`;
        } else {
            topPositionFrom = 0;
        }

        let animation = gsap.fromTo(serviceName, {
            top: topPositionFrom,
        }, {
            top: 0,
            duration: 0.6,
            ease: "ease",
        })
        animation.pause();

        item.addEventListener("mouseenter", (event) => {
            animation.play();
        })
        item.addEventListener("mouseleave", (event) => {
            animation.reverse();
        })
    })
}

function bestProductSection() {
    const bestProductWrapper = document.querySelector('.best-product__wrapper');
    const bestProductItem = document.querySelectorAll('.best-product__col');
    gsap.fromTo(bestProductItem, {
        y: "-20%",
        autoAlpha: 0,
    }, {
        y: "0%",
        autoAlpha: 1,
        duration: 1,
        stagger: 0.2,
        ease: "ease",
        scrollTrigger: {
            trigger: bestProductWrapper,
            start: "top-=100 bottom-=20%",
            // markers: true,
        },
    })
}

function featuredPortfolioSection() {
    let portfolioSwiper = new Swiper(".featured-portfolio__swiper", {
        modules: [ Navigation, Autoplay ],
        slidesPerView: 1.3,
        speed: 1000,
        spaceBetween: 20,
        navigation: {
            nextEl: ".featured-portfolio__button-next",
            prevEl: ".featured-portfolio__button-prev",
        },
        autoplay: {
            delay: 3000,
            reverseDirection: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 2.3,
                spaceBetween: 40,
            },
        }
    });
    portfolioSwiper.autoplay.stop();

    const portfolioModalSwiper = new Swiper(".modal-portfolio__swiper", {
        modules: [ Pagination, Navigation ],
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination",
        },
        navigation: {
            nextEl: ".modal-portfolio__button-next",
            prevEl: ".modal-portfolio__button-prev",
        }
    });

    const featuredPortfolioWrapper = document.querySelector('.featured-portfolio > .theme-container');
    const featuredPortfolioCaption = document.querySelector('.featured-portfolio__col-caption');
    const featuredPortfolioList = document.querySelectorAll('.featured-portfolio__col-list');
    let featuredSectionTl = gsap.timeline({
        scrollTrigger: {
            trigger: featuredPortfolioWrapper,
            start: "top-=100 bottom-=20%",
            // markers: true,
        },
        // onComplete: () => {
        //     portfolioSwiper.autoplay.start();
        // }
    });
    featuredSectionTl.fromTo(featuredPortfolioCaption, {
        x: "-30%",
        opacity: 0,
    }, {
        x: "0%",
        opacity: 1,
        duration: 1,
        ease: "ease",
    })
    .fromTo(featuredPortfolioList, {
        x: "75%",
        opacity: 0,
    }, {
        x: "0%",
        opacity: 1,
        duration: 1,
        ease: "power3.inOut",
    }, "-=0.8");
}
function featuredPortfolioResponsive() {
    // mobile responsive
    const featuredProjectMobileWrapper = document.querySelector('.featured-portfolio__mobile-wrapper');
    const featuredColCaption = document.querySelector('.featured-portfolio__col-caption');
    const featuredProjectButton = document.querySelector('.featured-portfolio__button');

    if (window.innerWidth < 992) {
        featuredProjectMobileWrapper.append(featuredProjectButton);
    } else {
        featuredColCaption.append(featuredProjectButton);
    }
}
function modalPortfolio() {
    // get data gallery attribute
    const portfolioItems = document.querySelectorAll('.portfolio-card__item');
    let modalImageWrapper = document.querySelector('.modal-portfolio__swiper .swiper-wrapper');

    portfolioItems.forEach((item) => {
        item.addEventListener("click", (e) => {
            const portfolioModalSwiper = new Swiper(".modal-portfolio__swiper", {
                modules: [ Pagination, Navigation ],
                slidesPerView: 1,
                pagination: {
                    el: ".swiper-pagination",
                },
                navigation: {
                    nextEl: ".modal-portfolio__button-next",
                    prevEl: ".modal-portfolio__button-prev",
                }
            });

            let portfolioItemID = e.target.getAttribute('data-portfolio');

            // select modal element
            let modalTitle = document.querySelector('.modal-portfolio__title');
            let modalDescription = document.querySelector('.modal-portfolio__description');
            let modalClient = document.querySelector('.modal-portfolio__value.client');
            let modalMaterial = document.querySelector('.modal-portfolio__value.material');
            let modalYear = document.querySelector('.modal-portfolio__value.year');
            let modalLocation = document.querySelector('.modal-portfolio__value.location');

            // get portfolio value
            let imageSwiper = portfolioJson[portfolioItemID].images;
            let title = portfolioJson[portfolioItemID].title;
            let client = portfolioJson[portfolioItemID].client;
            let material = portfolioJson[portfolioItemID].material;
            let year = portfolioJson[portfolioItemID].year;
            let location = portfolioJson[portfolioItemID].location;
            let description = portfolioJson[portfolioItemID].description;
            
            // add value into modal section
            modalTitle.innerHTML = title ? title : '-';
            modalClient.innerHTML = client ? client : '-';
            modalYear.innerHTML = year ? year : '-';
            modalLocation.innerHTML = location ? location : '-';
            modalDescription.innerHTML = description ? `<p>${description}</p>` : `<p>-<p>`;
            
            // modalMaterial.innerHTML = material ? material : '-';
            if(material.length != 0) {
                material.forEach(element => {
                    modalMaterial.innerText = element;
                });
            } else {
                modalMaterial.innerHTML = '-';
            }

            if (imageSwiper) {
                imageSwiper.forEach( (image) => {
                    // add image wrapper element
                    let swiperSlide = document.createElement('div');
                    swiperSlide.className = 'swiper-slide modal-portfolio__item';
    
                    // add image element
                    let swiperImage = document.createElement("img");
                    swiperImage.src = `${image.portfolio_image.url}`;
                    swiperImage.className = 'modal-portfolio__image';
                    swiperImage.alt = `${image.portfolio_image.alt}`;
    
                    // append image into image wrapper
                    swiperSlide.appendChild(swiperImage);
                    
                    // append image wrapper into swiper wrapper
                    modalImageWrapper.appendChild(swiperSlide);
                });
            }
        })
    })

    document.addEventListener('hidden.bs.modal', () => {
        modalImageWrapper.innerHTML = '';
    })
}

function ourCustomerSwiper() {
    const firstSwiper = new Swiper(".our-customer__swiper--first", {
        modules: [ Autoplay ],
        slidesPerView: 2.4,
        spaceBetween: 18,
        loop: true,
        speed: 4000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            reverseDirection: false,
        },
        breakpoints: {
            576: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 7.4,
                spaceBetween: 30,
            },
        }
    });
    const secondSwiper = new Swiper(".our-customer__swiper--second", {
        modules: [ Autoplay ],
        slidesPerView: 2.4,
        spaceBetween: 18,
        loop: true,
        speed: 4000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            reverseDirection: true,
        },
        breakpoints: {
            576: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 7.4,
                spaceBetween: 30,
            },
        }
    });
}

function articleSection() {
    const articleSection = document.querySelector(".article > .theme-container");
    const articleTitle = document.querySelector(".article__title");

    let mm = gsap.matchMedia()
    mm.add("(min-width: 992px)", () => {
        ScrollTrigger.create({
            trigger: articleSection,
            pin: articleTitle,
            start: "top top+=120",
            end: "bottom-=120 center",
            // markers: true
        });
    })

    // const articleItem = document.querySelectorAll('.article__item');
    // gsap.fromTo(articleItem, {
    //     y: 100,
    //     autoAlpha: 0,
    // }, {
    //     y: 0,
    //     autoAlpha: 1,
    //     duration: 0.8,
    //     stagger: 0.3,
    //     ease: "ease",
    //     scrollTrigger: {
    //         trigger: articleSection,
    //         start: "top center+=10%",
    //         // markers: true,
    //     },
    // })
}

document.addEventListener('DOMContentLoaded', () => {
    homeBannerSwiper();
    reasonSection();
    serviceSection();
    serviceResponsive();
    bestProductSection();
    featuredPortfolioSection();
    featuredPortfolioResponsive();
    modalPortfolio();
    ourCustomerSwiper();
    articleSection();
})

window.addEventListener('resize', () => {
    serviceResponsive();
    featuredPortfolioResponsive();
})